module.exports = __webpack_public_path__ + "media/bootstrap-icons/collection-5540020f.svg";